<template>
  <form
    @submit.prevent="handleSubmit"
    class="login-form"
  >
    <div
      v-show="alertMessage"
      class="login-alert-box"
    >
      {{ alertMessage }}
    </div>
    <standard-input
      name="email"
      label="Adres e-mail"
      class="login-input"
      :value="email"
      :info="errors.email"
      :valid="!errors.email"
      @input_change="onInput($event, 'email')"
      @input_focus="errors.email = ''"
    />
    <standard-input
      name="password"
      type="password"
      label="Hasło"
      class="login-input"
      :info="errors.password"
      :value="password"
      :valid="!errors.password"
      @input_change="onInput($event, 'password')"
      @input_focus="errors.password = ''"
    />
    <div class="forgotten-pass-wrapper">
      <a
        href="#"
        @click.prevent="passRecoverModal()"
        class="forgotten-pass-link"
      >
        Nie pamiętam hasła
      </a>
    </div>
    <standard-button
      text="Zaloguj się"
      class="login-button fluid"
      type="submit"
      :background-color="buttonColor"
    />
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StandardButton from '~/StandardButton';
import StandardInput from '~/StandardInput';

export default {
  components: {
    StandardButton,
    StandardInput,
  },
  data() {
    return {
      email: '',
      password: '',
      submitted: false,
      errors: {
        email: '',
        password: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      alertMessage: 'alert/getAlertMsg',
      buttonColor: 'brand/getPrimaryColor',
      linkColor: 'brand/getThirdColor',
    }),
    loggingIn() {
      return this.$store.state.auth.status.loggingIn;
    },
  },
  methods: {
    ...mapActions({
      login: 'auth/login',
      clearAlert: 'alert/clear',
      showAlert: 'alert/error',
      toggleModal: 'modal/openModal',
      closeModal: 'modal/closeModal',
      setCallback: 'modal/setCallback',
      setModalStep: 'modal/setModalStep',
      setModalMode: 'modal/setModalMode',
      setModalContent: 'modal/setContent',
    }),
    onInput(value, name) {
      this[name] = value;
    },
    checkForm() {
      this.errors = {
        email: '',
        password: '',
      };

      if (!this.email) {
        this.errors.email = 'Email wymagany';
      } else if (!this.validEmail(this.email)) {
        this.errors.email = 'Niepoprawny adres email';
      }
      if (!this.password) {
        this.errors.password = 'Podaj poprawne hasło';
      }

      if (!this.errors.email.length && !this.errors.password.length) {
        return true;
      }
      return false;
    },
    validEmail(email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    handleSubmit() {
      const { email, password } = this;
      this.submitted = true;

      if (this.checkForm()) {
        this.login({ email, password });
      }
    },
    passRecoverModal() {
      this.$router.push({ path: '/' });
      setTimeout(() => {
        this.setModalMode('logged-out');
        this.setModalStep('recover_pass');
        this.setModalContent({
          title: 'Resetowanie hasła',
        });
        this.toggleModal();
      }, 0);
    },
  },
};
</script>
